import { History } from "history";
import {
  TransactionHistoryDto,
  TransactionHistoryV2Dto,
} from "../../interfaces";
import { PaginateQuery, Paginated } from "../../models";

//#region Get Transaction History

export const GET_TRANSACTION_HISTORY = "GET_TRANSACTION_HISTORY";
export const GET_TRANSACTION_HISTORY_SUCCESS: any =
  "GET_TRANSACTION_HISTORY_SUCCESS";
export const GET_TRANSACTION_HISTORY_ERROR: any =
  "GET_TRANSACTION_HISTORY_ERROR";

export interface GetTransactionHistoryAction {
  type: typeof GET_TRANSACTION_HISTORY;
  payload: {
    request: PaginateQuery;
    history: History;
  };
}

export interface GetTransactionHistorySuccessAction {
  type: typeof GET_TRANSACTION_HISTORY_SUCCESS;
  payload: Paginated<TransactionHistoryDto>;
}

export interface GetTransactionHistoryErrorAction {
  type: typeof GET_TRANSACTION_HISTORY_ERROR;
  payload: any;
}
//#endregion

//#region Get Transaction History V2

export const GET_TRANSACTION_HISTORY_V2 = "GET_TRANSACTION_HISTORY_V2";
export const GET_TRANSACTION_HISTORY_V2_SUCCESS: any =
  "GET_TRANSACTION_HISTORY_V2_SUCCESS";
export const GET_TRANSACTION_HISTORY_V2_ERROR: any =
  "GET_TRANSACTION_HISTORY_V2_ERROR";

export interface GetTransactionHistoryV2Action {
  type: typeof GET_TRANSACTION_HISTORY_V2;
  payload: {
    request: PaginateQuery;
    history: History;
  };
}

export interface GetTransactionHistoryV2SuccessAction {
  type: typeof GET_TRANSACTION_HISTORY_V2_SUCCESS;
  payload: Paginated<TransactionHistoryV2Dto>;
}

export interface GetTransactionHistoryV2ErrorAction {
  type: typeof GET_TRANSACTION_HISTORY_V2_ERROR;
  payload: any;
}
//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | GetTransactionHistoryAction
  | GetTransactionHistorySuccessAction
  | GetTransactionHistoryErrorAction
  | GetTransactionHistoryV2Action
  | GetTransactionHistoryV2SuccessAction
  | GetTransactionHistoryV2ErrorAction;
